import { Injectable } from '@angular/core';

import { ClientConfigProductName, LazyClientConfig, LazyClientConfigBase, LazyClientConfigService } from '@frontend/vanilla/core';

import { CookieConfigs } from './cookie-injector-model';

@LazyClientConfig({ key: 'vnCookieInjector', product: ClientConfigProductName.SF })
@Injectable({
    providedIn: 'root',
    useFactory: CookieInjectorConfigFactory,
    deps: [LazyClientConfigService],
})
export class CookieInjectorConfig extends LazyClientConfigBase {
    cookieConfig: CookieConfigs;
}

export function CookieInjectorConfigFactory(service: LazyClientConfigService) {
    return service.get(CookieInjectorConfig);
}
